import {
  SET_ONE_POINT_FIVE_VCP,
  FETCH_ONE_POINT_FIVE_VCP_START,
  FETCH_ONE_POINT_FIVE_VCP_SUCCESS,
  FETCH_ONE_POINT_FIVE_VCP_FAILURE
} from "../actions/settings";

const initialState = {
  onePointFiveVcp: null,
  loading: false,
  error: null
};

const settingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ONE_POINT_FIVE_VCP_START:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_ONE_POINT_FIVE_VCP_SUCCESS:
      return {
        ...state,
        loading: false,
        onePointFiveVcp: action.payload,
        error: null
      };
    case FETCH_ONE_POINT_FIVE_VCP_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case SET_ONE_POINT_FIVE_VCP:
      return {
        ...state,
        onePointFiveVcp: action.payload
      };
    default:
      return state;
  }
};

export default settingsReducer;
